<template>
  <modal name="two-checkout-payment-modal" :width="500" :height="416" @opened="opened" @before-open="beforeOpen" :clickToClose="false">
    <div class="kt-portlet">
      <div class="kt-portlet__body">
          <div class="text-center">
            <img class="two-checkout-logo" src="../assets/logo/two-checkout-logo.svg" alt="stripe-logo">
          </div>
          <form type="post" id="payment-form" @submit.prevent="pay">
            <div class="form-group">
              <label for="name" class="label control-label">Name</label>
              <input type="text" id="name" class="form-control" v-model="name" required>
            </div>

            <div id="card-element"></div>

            <div class="mt-4" style="display: flex;justify-content: space-between;">
              <button class="btn btn-secondary btn-block mr-2" type="button" @click.prevent="$router.push({name: 'home'})">Pay Leter</button>
              <button class="btn btn-primary btn-block" type="submit" :disabled="complete">Pay</button>
            </div>
          </form>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      complete: false,
      jsPaymentClient: null,
      component: null,
      name: ''
    }
  },
  computed: {
    ...mapGetters({
      site: 'site/site',
      orderId: 'order/orderId'
    })
  },
  methods: {
    ...mapActions({
      confirmOrderForTwoCheckout: 'order/confirmOrderForTwoCheckout'
    }),
    beforeOpen() {
      // eslint-disable-next-line
      this.jsPaymentClient = new TwoPayClient(this.site.payment_gateway_code);
    },
    opened() {
      // eslint-disable-next-line
      this.component = this.jsPaymentClient.components.create('card');

      // eslint-disable-next-line
      this.component.mount('#payment-form > #card-element');
    },
    pay () {
      if (this.name === '') {
        return;
      }

      this.complete = true;

      this.jsPaymentClient.tokens.generate(this.component, {
        name: this.name
      }).then((response) => {
        this.confirmOrderForTwoCheckout({
          order_id: this.orderId,
          token: response.token
        }).then(() => {
          this.name = '';
          this.$swal({
            icon: 'success',
            title: 'Success...',
            text: 'Payment process is successfully done!',
          });

          this.$router.push({
            name: 'home',
          });
        });
      }).catch(() => {
        this.complete = false;

        this.$swal({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          });
      });
    }
  }
}
</script>

<style scoped>
img.two-checkout-logo {
  width: 12rem !important;
}
.field-wrapper {
  padding-right: 0px important;
}
</style>
